module.exports = __webpack_public_path__ + "img/dragons-rfc-logo-icon.2037c3fa.png";